// extracted by mini-css-extract-plugin
export default {"addressAction":"y8-z","loading":"z8-z"};